import type { AuthUser } from '@/shared/types/auth';

export interface AuthTokenResult {
  token: string;
  claims: Record<string, unknown>;
  authTime: string;
  signInProvider: string | null;
}

export interface PasswordSessionResponse {
  idToken: string;
  refreshToken: string;
  expiresIn: number;
  user: AuthUser;
}

export type PasswordSessionRequest = { email: string; password: string } | { refreshToken: string };

export class PasswordAuthError extends Error {
  constructor(
    readonly code: string,
    readonly status: number,
  ) {
    super(code);
    this.name = 'PasswordAuthError';
  }
}
